import { useRoutes } from "react-router-dom";
import { Layout, NotFound } from "../components";
import { routes } from "./utils";
import {
  AboutUs,
  Career,
  ContactUs,
  Home,
  OurProducts,
  ResearchInnovation,
  Overview,
  OurLeadership,
  OurHistory,
  CareerMain,
  SpecificeFeaturedJobs,
  Updates,
  SpecificBlog,
} from "@/pages";
import { Updates_Gallery } from "@/pages/Updates_Gallery";
import ProductDetailsPage from "@/pages/OurProducts/productDetailsPage/productDetailsPage";

const Router = () => {
  const element = useRoutes([
    {
      element: <Layout />,
      children: [
        { path: routes.root, element: <Home /> },
        {
          path: routes.about,
          element: <AboutUs />,
          children: [
            { path: routes.overview, element: <Overview /> },
            { path: routes.leadership, element: <OurLeadership /> },
            { path: routes.history, element: <OurHistory /> },
          ],
        },
        { path: routes.contact, element: <ContactUs /> },
        { path: routes.Blogs,
          element: <Updates/>,
        },
        {
          path: routes.update,
          element: <Updates_Gallery />,
        },
        {
          path: routes.specificblog,
          element: <SpecificBlog />,
        },
        {
          path: routes.career,
          element: <Career />,
          children: [
            { index: true, element: <CareerMain /> }, // Default page
            { path: routes.specificejob, element: <SpecificeFeaturedJobs /> }, // Job details
          ],
        },
        { path: routes.ourProducts, element: <OurProducts /> },
        { path: routes.productDetails, element: <ProductDetailsPage /> },
        { path: routes.researchInnovation, element: <ResearchInnovation /> },
      ],
    },
    { path: "*", element: <NotFound /> },
  ]);

  return element;
};

export default Router;
